<template>
  <AppHeaderDropdown right>
    <template slot="header">
      <span class="d-md-down-none align-middle">{{ user.USER_NAME }}</span>
      <img
        :src="user.USER_PROFILE_PIC_URL"
        class="img-avatar" >
    </template>
    <template slot="dropdown">
      <b-dropdown-header 
        tag="div" 
        class="text-center"><strong>{{ user.USER_PROFILE_FIRST_NAME }}</strong></b-dropdown-header>
      <b-dropdown-item @click="changePassword()"><i class="icon-key" /> Change Password</b-dropdown-item>
      <b-dropdown-item @click="logout()"><i class="icon-logout" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { auth } from '@/services/'

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data() {
    return {
      user: auth.getUser()
    }
  },
  methods: {
    logout () {
      auth.redirect()
    },
    changePassword () {
      let token = auth.getToken()
      let encryptedToken = auth.encryptToken(token)
      localStorage.clear()
      window.location.href = `${process.env.VUE_APP_CHANGE_PASSWORD_URL}?hash=${encryptedToken}&appId=USSE-2`
    }
  }
}
</script>
